import { Component, Input } from '@angular/core';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { UserInfo } from 'src/app/modules/shared/models/form/user-info.model';
import { OrganizationType } from 'src/app/modules/shared/models/staff/organization-type.enum';
import { User } from 'src/app/modules/shared/models/staff/user.model';

@Component({
  selector: 'app-dialog-jtys105-sp2',
  templateUrl: './dialog-jtys105-sp2.component.html',
  styleUrls: ['./dialog-jtys105-sp2.component.scss'],
})
export class DialogJtys105Sp2Component {
  @Input() data!: DialogConfig<{
    userList: User[];
    no_2_User: UserInfo;
    no_4_User: UserInfo;
  }>;

  selectedUserMap: { [key: string]: string } = {};

  userTreeNodesMap: { [key: string]: User[] } = {};

  no_4_DepartmentId: string = '';

  no_4_DepartmentName: string = '';

  no_2_DepartmentId: string = '';

  no_3_userId: string = '';

  no_4_userId: string = '';

  no_10_userId: string = '';

  no_11_userId: string = '';

  departments: {
    label: string;
    value: string;
    checked: boolean;
  }[] = [];

  departmentCheckMap: { [key: string]: boolean } = {};

  userList: User[] = [];

  noNeedThird: boolean = false;
  noNeedRest: boolean = false;

  constructor() {}

  ngOnInit() {
    this.prepareData();
  }

  onChange() {
    if (!this.no_4_userId) {
      this.no_3_userId = '';
    }
  }

  private prepareData() {
    // 然后根据单位id来过滤用户列表，获取建设单位的用户列表
    const users = this.data
      .data!.userList.filter(
        (user) => user.organizationType === OrganizationType.DEVELOPMENT,
      )
      .sort((a, b) => +b.postSortOrder! - +a.postSortOrder!);
    this.no_4_DepartmentId = this.data.data!.no_4_User.departmentId!.toString();
    this.no_4_DepartmentName = this.data.data!.no_4_User.departmentName!;
    this.no_2_DepartmentId =
      this.data.data!.no_2_User?.departmentId?.toString() || '';
    this.userList = users;
    const departmentsUserMap: { [key: string]: User[] } = {};
    const departments: { label: string; value: string; checked: boolean }[] =
      [];
    for (const user of users) {
      if (!departmentsUserMap[user.departmentId!]) {
        departmentsUserMap[user.departmentId!] = [];
        if (
          `${user.departmentId}` !== `${this.no_4_DepartmentId}` &&
          `${user.departmentId}` !== `${this.no_2_DepartmentId}`
        ) {
          if (!user.departmentName!.includes('领导')) {
            departments.push({
              label: user.departmentName!,
              value: user.departmentId!.toString(),
              checked: false,
            });
          }
        }
      }
      departmentsUserMap[`${user.departmentId!}`].push(user);
      if (!this.selectedUserMap[`${user.departmentId!}`]) {
        this.selectedUserMap[`${user.departmentId!}`] = user.id!.toString();
      }
    }

    this.no_4_userId = '';
    this.no_11_userId = this.data.data!.no_4_User.userId!.toString();

    this.userTreeNodesMap = departmentsUserMap;

    this.departments = departments;
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    const no_3_UserInfoList: UserInfo[] = [];
    if (this.no_3_userId) {
      const userInfo = new UserInfo();
      const user = this.userList.find(
        (user) =>
          `${user.id}` === `${this.no_3_userId}` &&
          `${user.departmentId}` === `${this.no_4_DepartmentId}`,
      );
      if (user) {
        userInfo.organizationType = user.organizationType;
        userInfo.organizationId = user.organizationId;
        userInfo.organizationShortName = user.organizationShortName;
        userInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        userInfo.userName = user.name;
        userInfo.departmentId = user.departmentId;
        userInfo.departmentName = user.departmentName;
        userInfo.postId = user.postId;
        userInfo.userId = user.id;
        userInfo.postName = user.postName;
        userInfo.postPerformance = user.postPerformance;
        userInfo.performance = user.performance;
        userInfo.sealHolder = user.sealHolder;
        no_3_UserInfoList.push(userInfo);
      }
    }
    const no_4_UserInfoList: UserInfo[] = [];
    if (this.no_4_userId) {
      const userInfo = new UserInfo();
      const user = this.userList.find(
        (user) =>
          `${user.id}` === `${this.no_4_userId}` &&
          `${user.departmentId}` === `${this.no_4_DepartmentId}`,
      );
      if (user) {
        userInfo.organizationType = user.organizationType;
        userInfo.organizationId = user.organizationId;
        userInfo.organizationShortName = user.organizationShortName;
        userInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        userInfo.userName = user.name;
        userInfo.departmentId = user.departmentId;
        userInfo.departmentName = user.departmentName;
        userInfo.postId = user.postId;
        userInfo.userId = user.id;
        userInfo.postName = user.postName;
        userInfo.postPerformance = user.postPerformance;
        userInfo.performance = user.performance;
        userInfo.sealHolder = user.sealHolder;
        no_4_UserInfoList.push(userInfo);
      }
    }

    const no_10_UserInfoList: UserInfo[] = [];
    if (this.no_10_userId) {
      const userInfo = new UserInfo();
      const user = this.userList.find(
        (user) =>
          `${user.id}` === `${this.no_10_userId}` &&
          `${user.departmentId}` === `${this.no_4_DepartmentId}`,
      );
      if (user) {
        userInfo.organizationType = user.organizationType;
        userInfo.organizationId = user.organizationId;
        userInfo.organizationShortName = user.organizationShortName;
        userInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        userInfo.userName = user.name;
        userInfo.departmentId = user.departmentId;
        userInfo.departmentName = user.departmentName;
        userInfo.postId = user.postId;
        userInfo.userId = user.id;
        userInfo.postName = user.postName;
        userInfo.postPerformance = user.postPerformance;
        userInfo.performance = user.performance;
        userInfo.sealHolder = user.sealHolder;
        no_10_UserInfoList.push(userInfo);
      }
    }

    const no_11_UserInfoList: UserInfo[] = [];
    if (this.no_11_userId) {
      const userInfo = new UserInfo();
      const user = this.userList.find(
        (user) =>
          `${user.id}` === `${this.no_11_userId}` &&
          `${user.departmentId}` === `${this.no_4_DepartmentId}`,
      );
      if (user) {
        userInfo.organizationType = user.organizationType;
        userInfo.organizationId = user.organizationId;
        userInfo.organizationShortName = user.organizationShortName;
        userInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        userInfo.userName = user.name;
        userInfo.departmentId = user.departmentId;
        userInfo.departmentName = user.departmentName;
        userInfo.postId = user.postId;
        userInfo.userId = user.id;
        userInfo.postName = user.postName;
        userInfo.postPerformance = user.postPerformance;
        userInfo.performance = user.performance;
        userInfo.sealHolder = user.sealHolder;
        no_11_UserInfoList.push(userInfo);
      }
    }

    const restUserInfoList: UserInfo[] = [];
    if (!this.noNeedRest) {
      for (const department of this.departments) {
        if (!department.checked) {
          continue;
        }
        const userId = this.selectedUserMap[`${department.value}`];
        const userInfo = new UserInfo();
        const user = this.userList.find(
          (user) =>
            `${user.id}` === `${userId}` &&
            `${user.departmentId}` === `${department.value}`,
        );
        if (user) {
          userInfo.organizationType = user.organizationType;
          userInfo.organizationId = user.organizationId;
          userInfo.organizationShortName = user.organizationShortName;
          userInfo.organizationName =
            user.organizationShortName ?? user.organizationName;
          userInfo.userName = user.name;
          userInfo.departmentId = user.departmentId;
          userInfo.departmentName = user.departmentName;
          userInfo.postId = user.postId;
          userInfo.userId = user.id;
          userInfo.postName = user.postName;
          userInfo.postPerformance = user.postPerformance;
          userInfo.performance = user.performance;
          userInfo.sealHolder = user.sealHolder;
          restUserInfoList.push(userInfo);
        }
      }
    }
    this.data.onConfirm!({
      userInfoList: restUserInfoList,
      no_3_UserInfoList,
      no_4_UserInfoList,
      no_10_UserInfoList,
      no_11_UserInfoList,
    });
  }

  get canConfirm() {
    if (!this.noNeedRest) {
      let count = 0;
      for (const department of this.departments) {
        if (department.checked) {
          count++;

          if (!this.selectedUserMap[`${department.value}`]) {
            return false;
          }
          // if (
          //   !this.cascaderValueMap[department.value] ||
          //   this.cascaderValueMap[department.value].length !== 2
          // ) {
          //   return false;
          // }
        }
      }
      if (count > 5) {
        return false;
      }
    }

    if (!this.no_11_userId) {
      return false;
    }

    return true;
  }
}
